import React, {memo} from 'react';
import PropTypes from 'prop-types';
import cl from 'classnames';
import {t} from '../../services/i18nHandler';
import './PageTabs.less';

function PageTabs({
  data, activeTab, disabled, onClick,
}) {
  return (
    <div className={`page-tab_wrap ${disabled ? 'disabled' : ''}`}>
      {data.map((item, index) => {
        const isObj = typeof item === 'object';
        const value = isObj ? item.label : item;
        const tabValue = isObj ? item.value : index;

        return (
          <span
            key={value}
            role="button"
            onClick={disabled ? null : () => onClick(tabValue)}
            className={cl('page-tab_item', {
              active: tabValue === activeTab,
              'default-active': data.length <= 1,
            })}
          >
            {t(value)}
          </span>
        );
      })}
    </div>
  );
}

PageTabs.defaultProps = {
  data: [],
  activeTab: 0,
  onClick: () => {},
  disabled: false,
};

PageTabs.propTypes = {
  data: PropTypes.arrayOf(PropTypes.shape({})),
  activeTab: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]),
  onClick: PropTypes.func,
  disabled: PropTypes.bool,
};

export default memo(PageTabs);
